
const state = {
  caseInfo: {} // 案件详情信息
}

const mutations = {
  /**
   * 保存案件详情信息
   * @param {any} state 状态数据
   * @param {any} view 数据
   */
  SET_CASR_INFO(state, data) {
    state.caseInfo = JSON.parse(JSON.stringify(data))
  }
}

const actions = {

  /**
   * 保存案件详情信息
   * @param {any} param0 与 store 实例具有相同方法和属性的 context 对象
   * @param {any} caseInfo 数据
   */
  setCaseInfo({ commit }, caseInfo) {
    commit('SET_CASR_INFO', caseInfo)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
